// A tagged wire format preserves nested timestamps (including nanoseconds) and
// avoids mistaking customer-authored objects for transport metadata.
export function encodeAdminValue(value) {
  if (value === undefined) return ["undefined"];
  if (value === null || typeof value !== "object") {
    if (typeof value === "number" && !Number.isFinite(value)) return ["number", String(value)];
    return ["value", value];
  }
  if (typeof value.toDate === "function" && typeof value.seconds === "number") return ["timestamp", [value.seconds, value.nanoseconds]];
  if (value instanceof Date) return ["date", value.toISOString()];
  if (Array.isArray(value)) return ["array", value.map(encodeAdminValue)];
  if (typeof value.path === "string" && typeof value.get === "function") return ["reference", value.path];
  if (typeof value.isEqual === "function" && typeof value.latitude === "number" && typeof value.longitude === "number") return ["geopoint", [value.latitude, value.longitude]];
  if (value instanceof Uint8Array) return ["bytes", Array.from(value)];
  return ["object", Object.entries(value).map(([key, child]) => [key, encodeAdminValue(child)])];
}

export class AdminTimestamp {
  constructor(seconds, nanoseconds) { this.seconds = seconds; this.nanoseconds = nanoseconds; }
  toMillis() { return this.seconds * 1000 + this.nanoseconds / 1e6; }
  toDate() { return new Date(this.toMillis()); }
  toJSON() { return { seconds: this.seconds, nanoseconds: this.nanoseconds }; }
  isEqual(other) { return other?.seconds === this.seconds && other?.nanoseconds === this.nanoseconds; }
  valueOf() { return `${String(this.seconds + 62135596800).padStart(12, "0")}.${String(this.nanoseconds).padStart(9, "0")}`; }
}

export function decodeAdminValue([type, value]) {
  switch (type) {
    case "undefined": return undefined;
    case "value": return value;
    case "number": return Number(value);
    case "timestamp": return new AdminTimestamp(...value);
    case "date": return new Date(value);
    case "array": return value.map(decodeAdminValue);
    case "object": return Object.fromEntries(value.map(([key, child]) => [key, decodeAdminValue(child)]));
    case "reference": return { path: value, id: value.split("/").pop() };
    case "geopoint": return { latitude: value[0], longitude: value[1] };
    case "bytes": return new Uint8Array(value);
    default: throw new Error("Unsupported admin record value");
  }
}
